<template>
  <div>
    <top-search title="Teklif Önizleme" />
    <div class="p-4 print:p-0">
      <button
        @click="generateReport()"
        class="bg-primary-900 flex mb-2 items-center justify-between space-x-1 text-primary-50 px-3 text-sm py-2 print:hidden rounded"
        title="Pdf Oluştur"
      >
        PDF Oluştur
      </button>
    </div>
  </div>
</template>

<script>
/*
      <vue-html2pdf
        :show-layout="false"
        :float-layout="false"
        :enable-download="true"
        :htmlToPdfOptions="htmlToPdfOptions()"
        :preview-modal="false"
        filename="teklif"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        :manual-pagination="true"
        :pdf-quality="2"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
      >
        <section slot="pdf-content" class="w-full">
          <component
            :is="config.appName"
            :id="$route.params.lead_id"
            :result="result"
          />
        </section>
      </vue-html2pdf>


import VueHtml2pdf from "vue-html2pdf";
    VueHtml2pdf,
    
      */
import httpService from "../services/http"; 
import config from "../config";
import TopSearch from "../components/Ui/TopSearch.vue";

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      config,
      result: [],
      values: {}
    };
  },
  components: { 
    TopSearch
  },
  methods: {
    findKey(key) {
      let rreturn = Object.values(this.result.answers).find(e => {
        return e.text == key;
      });
      if (rreturn) {
        return rreturn.value;
      }
    },
    htmlToPdfOptions() {
      return {
        margin: 0,

        filename: this.findKey("İsim Soyisim") + ".pdf",

        image: {
          type: "jpeg",
          quality: 1
        },

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        },

        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait"
        },
        pagebreak: { after: ".pdf-item" }
      };
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress(ee) {
      console.log(ee);
    },
    getData() {
      httpService
        .bidDetail(this.$route.params.lead_id, this.$route.params.id)
        .then(response => {
          this.result = response.data.result;
          this.result.answers = JSON.parse(this.result.answers);
        });
    }
  }
};
</script>
